import { render } from "./ManualForm.vue?vue&type=template&id=163635ac&scoped=true"
import script from "./ManualForm.vue?vue&type=script&lang=js"
export * from "./ManualForm.vue?vue&type=script&lang=js"

import "./ManualForm.vue?vue&type=style&index=0&id=163635ac&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163635ac"]])

export default __exports__